/* eslint-disable @typescript-eslint/no-explicit-any */
import ElementAnimation from 'containers/OmonymsFrame/ElementAnimation';
import SvgObject from 'containers/OmonymsFrame/SvgObject';
import * as d3 from 'd3';
import {assert} from 'utils/assert';
import {debuggableClass, memo} from 'utils/decorators';

@debuggableClass
export default class CardGroup {
  constructor(
    public parent: SvgObject,
    public groupG: SVGGElement,
    public getMinStartTime: () => number,
  ) {}
  @memo get sel() {
    return d3.select(this.groupG);
  }
  @memo get bbox() {
    return this.sel.node()!.getBBox();
  }
  @memo get showIntersectionRatio() {
    console.log(
      'showIntersectionRatio',
      (this.bbox.y + this.bbox.height * 0.1) / this.parent.svgRootBboxHeight,
    );
    return (this.bbox.y + this.bbox.height * 0.1) / this.parent.svgRootBboxHeight;
  }
  showBbox() {
    this.sel
      .append('rect')
      .attr('x', this.bbox.x)
      .attr('y', this.bbox.y)
      .attr('width', this.bbox.width)
      .attr('height', this.bbox.height)
      .attr('stroke', 'red')
      .attr('fill', 'none');
    return this;
  }
  @memo get groupId() {
    return this.sel.attr('id');
  }
  @memo get groupNo() {
    const prefix = 'Frame ';
    assert(this.groupId.startsWith(prefix));
    const numPart = this.groupId.slice(prefix.length);
    assert(Number.isFinite(Number(numPart)));
    return Number(numPart);
  }
  @memo get titleTextGSel() {
    return this.sel.select('g.card-group > g');
  }
  @memo get ellipsePathSel() {
    return this.sel.select('path');
  }
  @memo get ellipseTextSel() {
    return this.sel.select('[id^="word_"]');
  }
  @memo get inOutArrowGroup() {
    return this.sel.select('[id^="meaning_"]');
  }
  @memo get meaningSel() {
    return this.sel.select('[id^="meaning_"]').style('font-weight', 300);
  }
  markGroupWithClass() {
    d3.select(this.groupG).classed('card-group', true);
    return this;
  }
  moveEllipsePathToParent() {
    const sel = this.ellipsePathSel.remove();
    this.groupG.append(sel.node() as any);
    return this;
  }
  @memo get inTextSel() {
    // console.log(this.sel.selectAll('text'));
    return this.sel.select('.card-group > text:nth-of-type(1)');
  }
  @memo get outTextSel() {
    return this.sel.select('.card-group > text:nth-of-type(2)');
  }
  @memo get arrowPathSel() {
    return this.sel.select('path:nth-of-type(1)');
  }
  // @memo get titleAppearAnimation() {
  //   return new ElementAnimation(
  //     this.titleTextGSel.node() as SVGElement,
  //     this.animationStartTime,
  //     1000,
  //     'UPSCALE',
  //   );
  //   // (res as any).bboxTargetElem = this.rectSel.node();
  //   // (res as any).viewBoxCenter = this.parent.viewBoxCenter;
  //   // Object.defineProperty(res, 'bboxTargetElem', {value: this.rectSel.node()});
  //   // return res;
  // }
  // @memo get ellipseAppearAnimation() {
  //   return new ElementAnimation(
  //     this.ellipsePathSel.node() as SVGElement,
  //     this.titleAppearAnimation.startTime + 500,
  //     1000,
  //     'DRAW_PATH',
  //   );
  // }
  @memo get ellipseTextAppearAnimation() {
    return new ElementAnimation(this.ellipseTextSel.node() as SVGElement, 0, 500, 'UPSCALE');
  }
  @memo get meaningAppearAnimation() {
    if (!this.meaningSel.node()) {
      console.log(this);
      return null;
    }
    return new ElementAnimation(
      this.meaningSel.node() as SVGElement,
      this.ellipseTextAppearAnimation.startDelay + 200,
      300,
      'FADE_IN',
    );
  }
  @memo get arrowAppearAnimation() {
    return new ElementAnimation(
      this.arrowPathSel.node() as SVGElement,
      this.meaningAppearAnimation?.startDelay ?? 0,
      1000,
      'LEFT_RIGHT',
    );
  }
  // @memo get inTextAppearAnimation() {
  //   return new ElementAnimation(
  //     this.inTextSel.node() as SVGElement,
  //     this.ellipseAppearAnimation.startTime + 500,
  //     1000,
  //     'UPSCALE',
  //   );
  // }
  // @memo get outTextAppearAnimation() {
  //   return new ElementAnimation(
  //     this.outTextSel.node() as SVGElement,
  //     this.arrowAppearAnimation.startTime + 500,
  //     1000,
  //     'LEFT_RIGHT',
  //   );
  // }
  setInitialState() {
    // this.showBbox();
    this.markGroupWithClass();
    // this.moveEllipsePathToParent();
    this.ellipseTextAppearAnimation.setInitialState();
    if (this.meaningAppearAnimation) {
      this.meaningAppearAnimation.setInitialState();
    }
    // this.titleAppearAnimation.setInitialState();
    // this.ellipseAppearAnimation.setInitialState();
    // this.inTextAppearAnimation.setInitialState();
    // this.outTextAppearAnimation.setInitialState();
    this.arrowAppearAnimation.setInitialState();
    return this;
  }
  start() {
    setTimeout(() => {
      this.startAnimation();
    }, Math.max(0, this.startTime - Number(new Date())));
  }
  @memo get started() {
    return false;
  }
  @memo get startTime() {
    return Math.max(this.getMinStartTime(), Number(new Date()));
  }
  startAnimation() {
    Object.defineProperty(this, 'started', {value: true});

    this.ellipseTextAppearAnimation.start();
    if (this.meaningAppearAnimation) {
      this.meaningAppearAnimation.start();
    }
    // this.titleAppearAnimation.start();
    // this.ellipseAppearAnimation.start();
    // this.inTextAppearAnimation.start();
    // this.outTextAppearAnimation.start();
    this.arrowAppearAnimation.start();
    return this;
  }
}
